import { GET_ELIGIBLE_DELEGATE_STRUCTS } from "../../../../enums/MyDivision/Delegation/RequestsDelegation.types";

export const getEligibleDelegateStructsAction = (data) => {
    return {
        type: GET_ELIGIBLE_DELEGATE_STRUCTS,
        payload: data,
    };
};